import styled from 'styled-components';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { Body2, colors, Overline, spacing, Subtitle1 } from 'ui/theme';

export const CardWrapper = styled.div`
  box-sizing: border-box;
  padding: ${spacing.plusHalf} ${spacing.double};
  background-color: ${colors.white};
  border: solid ${spacing.single} ${colors.grey15};
  border-radius: ${spacing.half};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing.base};
`;

export const Details = styled.div`
  flex-grow: 1;
`;

export const Actions = styled.div`
  flex-grow: 0;
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const Heading = styled(Subtitle1)`
  margin-top: 0;
  margin-bottom: ${spacing.quarter};
`;

export const Metadata = styled(Body2)`
  margin-top: 0;
  margin-bottom: 0;
  color: ${colors.textSecondary};
`;

export const BodyHeading = styled(Overline)`
  color: ${colors.textSecondary};
  display: block;
  margin-top: ${spacing.double};
  margin-bottom: ${spacing.plusHalf};
`;

export const CardBody = styled(CollapsibleContent)``;

export const Row = styled.div`
  display: flex;

  & + & {
    margin-top: ${spacing.double};
  }
`;

export const Name = styled(Body2)`
  margin-top: 0;
  margin-bottom: 0;
`;
